import OrderModal from "../components/modals/Order/OrderModal";

const OrderPage = ({  }) => {
  return (
      <OrderModal />
  );
}

export default OrderPage;
